import { LEARNING_LAB_ROUTES, MAIN_ROUTES, SERVICES_ROUTES } from "@/constants/routes";
import { LabDataType } from "../components/labDataType";

export const LAB_DATA: LabDataType[] = [
  {
    labSku: "Cisco Nexus 9000 Virtual Lab",
    id: 75,
    product_id: 20,
    category_id: 9,
    duration: 5,
    price: 275,
  },
  {
    labSku: "Cisco HyperFlex Lab",
    id: 69,
    product_id: 21,
    category_id: 9,
    duration: 2,
    price: 375,
    url: `${MAIN_ROUTES.SERVICES}${SERVICES_ROUTES.LEARNING_LABS}${LEARNING_LAB_ROUTES.CISCO_HYPERFLEX}`,
  },
  {
    labSku: "Cisco Nexus Lab",
    id: 72,
    product_id: 22,
    category_id: 9,
    duration: 5,
    price: 450,
  },
  {
    labSku: "Cisco UCS LAB",
    id: 73,
    product_id: 23,
    category_id: 9,
    duration: 5,
    price: 450,
  },
  {
    labSku: "Cisco MDS Lab",
    id: 71,
    product_id: 24,
    category_id: 9,
    duration: 5,
    price: 500,
  },
  {
    labSku: "Cisco ACI V2 Lab",
    id: 76,
    product_id: 25,
    category_id: 9,
    duration: 6,
    price: 625,
    url: `${MAIN_ROUTES.SERVICES}${SERVICES_ROUTES.LEARNING_LABS}${LEARNING_LAB_ROUTES.CISCO_ACI}`,
  },
  {
    labSku: "Cisco ACI-MULTISITE-MultiPOD",
    id: 77,
    product_id: 26,
    category_id: 9,
    duration: 6,
    price: 1000,
    url: `${MAIN_ROUTES.SERVICES}${SERVICES_ROUTES.LEARNING_LABS}${LEARNING_LAB_ROUTES.CISCO_ACI}`,
  },
  {
    labSku: "CCIE Data Center Lab",
    id: 74,
    product_id: 27,
    category_id: 9,
    duration: 7,
    price: 1500,
  },
  {
    labSku: "CCIE Data Center Lab",
    id: 75,
    product_id: 28,
    category_id: 9,
    duration: 30,
    price: 4500,
  },
];
